import { Loading, Message, MessageBox } from "element-ui";
import router from "@/router";
import store from "@/store";
import { handlerExport } from "@/utils/tools";
// // 引入进度条
import nprogress from "nprogress";
// // 引入进度条样式
import "nprogress/nprogress.css";

/**
 * 请求拦截器
 * @param {Object} config - Axios 请求配置对象
 * @returns {Object} 处理后的请求配置对象
 */
export const requestInterceptor = (config) => { 
  // 进度条开始
  showLoading(config);
  // config: 配置对象
  const token = store.getters["user/token"];
  token && (config.headers.token = token);
  if (!config.headers.identity) {
    config.headers.identity = getIdentityFromRoute(router.currentRoute);
  }
  return config;
}

/**
 * 响应拦截器
 * @param {Object} response - HTTP 响应对象
 * @returns {Object} 处理后的响应对象
 */
export const responseInterceptor = (res) => {
  //成功的回调函数
    // 进度条结束
    if (res.data instanceof Blob) {
      let reader = new FileReader();
      reader.readAsText(res.data);
      reader.onload = function (result) {
        try {
          let data = JSON.parse(result.target.result);
          tip(data.message);
        } catch (error) {
          handlerExport(res);
        }
      };
      // nprogress.done()
      endLoading(res.config);
      return false;
    }
    if (res.data.code !== 0 && res.data.code !== 200) {
      //订单合同签章页提示
      if (!res.config.hideTip) {
        tip(res.data.message);
      }
      if (res.data.code == 4000) {
        location.href =
          process.env.VUE_APP_EXTERNAL_LINK +
          "/certification/company";
      }
    }
    // nprogress.done()
    endLoading(res.config);
    return res.data;
}

export const handleError = (error) => {
  //响应失败的回调函数
    const { response, config } = error;
    endLoading(config);
    if (config?.errorHandle) {
      let res = config.errorHandle(response);
      if (res instanceof Promise) {
        return res;
      }
      return Promise.resolve(res);
    }
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.data.code, response.data.message);
      return Promise.reject(response);
    } else {
      return Promise.reject(error);
    }
}



/**
 * 递归获取路由的meta.identity
 * @param route 当前路由对象
 * @returns identity或undefined
 */
const getIdentityFromRoute = (route) => {
  // matched数组按层级从父到子排列，从后往前遍历即为从当前路由向根路由递归
  for (let i = route.matched.length - 1; i >= 0; i--) {
    if (route.matched[i].meta && route.matched[i].meta.identity) {
      return route.matched[i].meta.identity;
    }
  }
  return undefined;
};


nprogress.configure({ showSpinner: false });

let loading = null; //定义loading变量

/**
 * 显示loading加载
 * @param config
 */
let showLoading = (config) => {
  //get请求，显示进度条
  if (config.method.toLowerCase() === "get") {
    nprogress.start();
    return;
  }

  loading = Loading.service({
    fullscreen: true,
    text: "Loading",
    customClass: "create-isLoading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.6)",
  });
};
/**
 * 结束loading
 */
let endLoading = () => {
  nprogress.done();
  loading && loading.close();
};

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
let msgBox = null;
const toLogin = (message) => {
  if (msgBox) {
    return;
  }
  msgBox = MessageBox.confirm(message, '提示', {
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: '确认',
  }).then(() => {
    store.dispatch("user/resetToken")
    location.reload();
  });

};

const tip = (msg) => {
  Message(msg);
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin(other);
      break;
    default:
      Message.error(other || "请求失败");
  }
};

